import {
    useHistory,
    useLocation,
    useRouteMatch,
    useParams
} from 'react-router-dom';

/*
 * When you have a component or function that needs route hooks
 *
*/

export const WithRouteProps = ({render}) => {
    const match = useRouteMatch();
    const history = useHistory();
    const params = useParams();
    const location = useLocation();
    const navigate = history.push; // useNavigate();
    const goBack = history.goBack; // navigate(-1);

    return render({
        history,
        goBack,
        location,
        match,
        navigate,
        params,
    });
};

export default WithRouteProps;
